import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { handleErrors, headerBuilder, paramBuilder } from '../http';
export var fetchTenants = function fetchTenants() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get('/app/system-coordinator/api/v1/tenants', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      tenants: response.data.tenants,
      nextPageToken: response.data.nextPageToken
    };
  })["catch"](handleErrors);
};
export var fetchTenant = function fetchTenant() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var slug = options.slug;

  if (!slug) {
    throw new Error('fetchTenant failed! The option "slug" is required.');
  } // Build URL and fetch the space.


  return axios.get("/app/system-coordinator/api/v1/tenants/".concat(slug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      tenant: response.data.tenant
    };
  })["catch"](handleErrors);
};
export var updateTenant = function updateTenant() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var slug = options.slug,
      tenant = options.tenant;

  if (!tenant) {
    throw new Error('updateTenant failed! The option "tenant" is required.');
  }

  if (!slug) {
    throw new Error('updateTenant failed! The option "slug" is required.');
  }

  return axios.put("/app/system-coordinator/api/v1/tenants/".concat(slug), tenant, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      tenant: response.data.tenant
    };
  })["catch"](handleErrors);
};
export var createTenant = function createTenant() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tenant = options.tenant;

  if (!tenant) {
    throw new Error('createTenant failed! The option "tenant" is required.');
  }

  return axios.post('/app/system-coordinator/api/v1/tenants', tenant, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      tenant: response.data.tenant
    };
  })["catch"](handleErrors);
};
export var deleteTenant = function deleteTenant() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var slug = options.slug;

  if (!slug) {
    throw new Error('createTenant failed! The option "slug" is required.');
  }

  return axios["delete"]("/app/system-coordinator/api/v1/tenants/".concat(slug), {
    params: _objectSpread(_objectSpread({}, paramBuilder(options)), {}, {
      deleteDatabase: options.deleteDatabase || undefined
    }),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      tenant: response.data.tenant
    };
  })["catch"](handleErrors);
};
export var fetchSystem = function fetchSystem() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the system config.
  return axios.get('/app/system-coordinator/components/core/app/api/v1/config', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var updateSystem = function updateSystem() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var system = options.system;

  if (!system) {
    throw new Error('updateSystem failed! The option "system" is required.');
  } // Build URL and fetch the system config.


  return axios.put('/app/system-coordinator/components/core/app/api/v1/config', system, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var fetchSystemUser = function fetchSystemUser() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get('/app/system-coordinator/api/v1/platform/system-user', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      user: response.data
    };
  })["catch"](handleErrors);
};
export var updateSystemUser = function updateSystemUser() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var user = options.user;

  if (!user) {
    throw new Error('updateSystemUser failed! The option "user" is required.');
  }

  return axios.put('/app/system-coordinator/api/v1/platform/system-user', user, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      user: response.data
    };
  })["catch"](handleErrors);
};
export var fetchSystemIngress = function fetchSystemIngress() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get('/app/system-coordinator/api/v1/platform/ingress', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      ingress: response.data
    };
  })["catch"](handleErrors);
};
export var fetchTaskDbAdapters = function fetchTaskDbAdapters() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get("/app/system-coordinator/api/v1/meta/task-db-adapters", {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return response.data;
  }) // .then(response => ({ space: response.data.space }))
  ["catch"](handleErrors);
};
export var fetchTaskDbAdapter = function fetchTaskDbAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get("/app/system-coordinator/api/v1/meta/task-db-adapters/".concat(options.type), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var fetchSystemDefaultTaskDbAdapter = function fetchSystemDefaultTaskDbAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get("/app/system-coordinator/api/v1/platform/default-task-db-adapter", {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var updateSystemDefaultTaskDbAdapter = function updateSystemDefaultTaskDbAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var adapter = options.adapter;

  if (!adapter) {
    throw new Error('updateSystemDefaultTaskDbAdapter failed! The option "adapter" is required.');
  }

  return axios.put("/app/system-coordinator/api/v1/platform/default-task-db-adapter", adapter, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var fetchSystemDefaultSmtpAdapter = function fetchSystemDefaultSmtpAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get('/app/system-coordinator/api/v1/platform/default-smtp-adapter', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var updateSystemDefaultSmtpAdapter = function updateSystemDefaultSmtpAdapter() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var adapter = options.adapter;

  if (!adapter) {
    throw new Error('updateSystemDefaultSmtpAdapter failed! The option "adapter" is required.');
  }

  return axios.put('/app/system-coordinator/api/v1/platform/default-smtp-adapter', adapter, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var fetchSystemFilestore = function fetchSystemFilestore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Build URL and fetch the space.
  return axios.get('/app/system-coordinator/components/agent/app/api/v1/spaces/SYSTEM/filestores/system', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};
export var updateSystemFilestore = function updateSystemFilestore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filestore = options.filestore;

  if (!filestore) {
    throw new Error('updateSystemFilestore failed! The option "adapter" is required.');
  }

  return axios.put('/app/system-coordinator/components/agent/app/api/v1/spaces/SYSTEM/filestores/system', filestore, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      filestore: response.data.filestore
    };
  })["catch"](handleErrors);
};
var VALID_RESTARTABLE_COMPONENTS = ['agent', 'core', 'discussions', 'loghub', 'topics'];
export var postPlatformComponentRestart = function postPlatformComponentRestart() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.component || !VALID_RESTARTABLE_COMPONENTS.includes(options.component)) {
    throw new Error('postPlatformComponentRestart failed! The "component" option was missing or invalid.');
  }

  return axios.post("/app/system-coordinator/api/v1/platform/components/".concat(options.component, "/restart")).then(function (_ref) {
    var data = _ref.data;
    return {
      component: data.component,
      message: data.message
    };
  })["catch"](handleErrors);
};
export var fetchPlatformComponentStatus = function fetchPlatformComponentStatus() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/api/v1/platform/components').then(function (_ref2) {
    var data = _ref2.data;
    return {
      components: data.components
    };
  })["catch"](handleErrors);
};
export var systemLogin = function systemLogin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var username = options.username,
      password = options.password;
  return axios.post('/app/system-coordinator/login', {
    username: username,
    password: password
  }, {}).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};
export var refreshSystemToken = function refreshSystemToken() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.post('/app/system-coordinator/refresh', {}, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return response.data;
  })["catch"](handleErrors);
};
export var fetchCassandraConfig = function fetchCassandraConfig() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/api/v1/platform/cassandra', {}, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var fetchElasticSearchConfig = function fetchElasticSearchConfig() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/api/v1/platform/elasticsearch', {}, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapter: response.data.adapter
    };
  })["catch"](handleErrors);
};
export var fetchSystemLicense = function fetchSystemLicense() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/components/core/app/api/v1/license', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var deleteSystemLicense = function deleteSystemLicense() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios["delete"]('/app/system-coordinator/components/core/app/api/v1/license', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var resetSystemLicense = function resetSystemLicense() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.put('/app/system-coordinator/components/core/app/api/v1/license/reset', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var importSystemLicense = function importSystemLicense() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var content = options.content;
  var data = new FormData();
  data.set('content', content);
  var headers = {
    'Content-Type': 'multipart/form-data'
  };
  return axios.post('/app/system-coordinator/components/core/app/api/v1/license', data, {
    headers: headers
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var fetchSystemLicenseStats = function fetchSystemLicenseStats() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/components/core/app/api/v1/license/statistics', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};
export var fetchSystemLicenseCheck = function fetchSystemLicenseCheck() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get('/app/system-coordinator/components/core/app/api/v1/license/check', {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      system: response.data
    };
  })["catch"](handleErrors);
};